export default __webpack_public_path__ + "static/media/010103202120102.e2c4d87d.png";